/**
 * @format
 */
import { ActivitiesService } from '@/scripts/services/activities/activities-service';

export const ActivityServiceMixin = {
    data() {
        return {
            contactId: null,
            activities: [],
            isActivitiesLoading: false,
        }
    },

    methods: {
        getActivities({ contactId, dealId, pageSize, skippedRecords, type = 'All', search, userFilter}) {
            this.isActivitiesLoading = true;

            ActivitiesService.getActivities({
                contactId,
                dealId,
                pageSize,
                skippedRecords,
                type,
                search,
                userFilter,
                filteredActivityType: this.filteredActivityType
            })
            .then(({ response, groups }) => {
                this.areAllActivitiesFetched = response.data.value.length < pageSize;
                this.contactId = contactId || null;

                if (this.activities && this.activities.length > 0) {
                    this.activities = [...this.activities, ...groups];
                } else {
                    this.activities = [...groups];
                }
            })
            .catch((error) => {
                this.areAllActivitiesFetched = true;
                this.$helpers.showFailNotification(
                    'An error occurred while fetching your activities.',
                    { error },
                );
            })
            .finally(() => {
                this.isActivitiesLoading = false;
            });
        },

        showMoreRecords({ contactId, pageSize, type, search }) {
            this.pagesSkipped++;
            this.getActivities({
                contactId,
                pageSize,
                skippedRecords: pageSize * this.pagesSkipped,
                type,
                search,
            });
        },

        showMoreAssignedRecords({ dealId, pageSize, type, search, userFilter }) {
            this.pagesSkipped++;
            this.getActivities({
                dealId,
                pageSize,
                skippedRecords: pageSize * this.pagesSkipped,
                type,
                search,
                userFilter,
            });
        },
    }
}